//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import DeviceInfoDrawer from "./modules/DeviceInfoDrawer";
import DeviceDrawer from "./modules/DeviceDrawer";
import { JeecgListMixin } from '@/mixins/JeecgListMixin';
import { getAction } from '@/api/manage';
export default {
  name: 'ProductInfoList',
  mixins: [JeecgListMixin],
  components: {
    DeviceInfoDrawer: DeviceInfoDrawer,
    DeviceDrawer: DeviceDrawer
  },
  data: function data() {
    return {
      pagePath: '/ea/asset/car',
      title: '运维车辆',
      autoLoadInit: false,
      // 表头
      columns: [{
        title: '序号',
        dataIndex: '',
        key: 'rowIndex',
        width: 60,
        align: 'center',
        customRender: function customRender(t, r, index) {
          return parseInt(index) + 1;
        }
      }, {
        dataIndex: 'card',
        colName: 'card',
        title: '车牌号',
        align: 'center'
      }, {
        dataIndex: 'productName',
        colName: 'productName',
        title: '产品名称',
        align: 'center'
      }, {
        dataIndex: 'model',
        colName: 'model',
        title: '规格型号',
        align: 'center'
      }, {
        dataIndex: 'companyName',
        colName: 'companyName',
        title: '供应商',
        align: 'center'
      }, {
        dataIndex: 'assetCode',
        colName: 'asset_code',
        title: '资产编号',
        align: 'center'
      }, {
        dataIndex: 'sn',
        colName: 'sn',
        title: '出厂编号',
        align: 'center'
      }, {
        dataIndex: 'worth',
        colName: 'worth',
        title: '原值（元）',
        align: 'center'
      }, {
        dataIndex: 'productionDate',
        colName: 'production_date',
        title: '生厂日期',
        align: 'center'
      }, {
        dataIndex: 'purchaseDate',
        colName: 'purchase_date',
        title: '购置日期',
        align: 'center'
      }, {
        dataIndex: 'status_dictText',
        colName: 'status',
        title: '资产状态',
        align: 'center'
      }, {
        title: '操作',
        dataIndex: 'action',
        align: 'center',
        width: 120,
        scopedSlots: {
          customRender: 'action'
        }
      }],
      companyList: [],
      category: '31',
      url: {
        queryCompany: '/ea/company/info/queryCompanyName'
      }
    };
  },
  created: function created() {
    this.loadCompany();
    this.queryParam.category = this.category;
    this.loadData();
  },
  computed: {},
  methods: {
    loadCompany: function loadCompany() {
      var that = this;
      that.companyList = [];
      getAction(this.url.queryCompany).then(function (res) {
        if (res.success) {
          that.companyList = res.result;
        }
      });
    },
    handleAdd: function handleAdd() {
      this.$refs.modalForm.category = this.category;
      this.$refs.modalForm.add();
      this.$refs.modalForm.title = '新增：' + this.title;
      this.$refs.modalForm.disableSubmit = false;
      this.$refs.modalForm.showTab = false;
      this.$refs.modalForm.showContact = false;
    },
    handleEdit: function handleEdit(record) {
      this.$refs.modalForm.category = this.category;
      this.$refs.modalForm.edit(record);
      this.$refs.modalForm.title = '编辑：' + this.title;
      this.$refs.modalForm.disableSubmit = false;
      this.$refs.modalForm.showTab = true;
      this.$refs.modalForm.showContact = true;
    },
    handleDetail: function handleDetail(record) {
      this.$refs.deviceModal.category = this.category;
      this.$refs.deviceModal.edit(record);
      this.$refs.deviceModal.title = this.title + '详情';
      this.$refs.deviceModal.disableSubmit = true;
    },
    modalFormOk: function modalFormOk() {
      this.queryParam = {
        category: this.category
      };
      this.loadData(1);
    },
    searchReset: function searchReset() {
      this.queryParam = {
        category: this.category
      };
      this.dates = {};
      this.loadData(1);
    },
    filterOption: function filterOption(input, option) {
      return option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0;
    }
  }
};